function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 1000,
  cy: 1000,
  r: 960.952,
  fill: "white",
  stroke: "white",
  strokeWidth: 78.0966
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1076:538)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1432.36 1559.79L1472.77 1463.14M1569.42 1503.55L1472.77 1463.14M1513.18 1366.48L1472.77 1463.14M1376.11 1422.73L1472.77 1463.14",
  stroke: "black",
  strokeWidth: 40.278
}), /*#__PURE__*/React.createElement("path", {
  d: "M966.309 1758.45L1006.72 1661.79M1103.37 1702.2L1006.72 1661.79M1047.13 1565.14L1006.72 1661.79M910.063 1621.38L1006.72 1661.79",
  stroke: "black",
  strokeWidth: 40.278
}), /*#__PURE__*/React.createElement("path", {
  d: "M1559.8 567.592L1463.14 527.182M1503.55 430.527L1463.14 527.182M1366.49 486.773L1463.14 527.182M1422.73 623.838L1463.14 527.182",
  stroke: "black",
  strokeWidth: 40.278
}), /*#__PURE__*/React.createElement("path", {
  d: "M1758.45 1033.6L1661.8 993.188M1702.21 896.533L1661.8 993.188M1565.14 952.779L1661.8 993.188M1621.39 1089.84L1661.8 993.188",
  stroke: "black",
  strokeWidth: 40.278
}), /*#__PURE__*/React.createElement("path", {
  d: "M440.064 1432.32L536.72 1472.73M496.31 1569.39L536.72 1472.73M633.375 1513.14L536.72 1472.73M577.129 1376.08L536.72 1472.73",
  stroke: "black",
  strokeWidth: 40.278
}), /*#__PURE__*/React.createElement("path", {
  d: "M567.564 440.027L527.155 536.683M430.5 496.273L527.155 536.683M486.746 633.338L527.155 536.683M623.81 577.092L527.155 536.683",
  stroke: "black",
  strokeWidth: 40.278
}), /*#__PURE__*/React.createElement("path", {
  d: "M1033.6 241.406L993.19 338.061M896.535 297.652L993.19 338.061M952.781 434.717L993.19 338.061M1089.85 378.471L993.19 338.061",
  stroke: "black",
  strokeWidth: 40.278
}), /*#__PURE__*/React.createElement("path", {
  d: "M241.424 966.305L338.079 1006.71M297.67 1103.37L338.079 1006.71M434.734 1047.12L338.079 1006.71M378.488 910.059L338.079 1006.71",
  stroke: "black",
  strokeWidth: 40.278
}));

function SvgXtarotX2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1076:538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2000,
    height: 2000
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtarotX2);
export default __webpack_public_path__ + "static/media/xtarot-x2.422023cb.svg";
export { ForwardRef as ReactComponent };